// Load Image form External URL
export const getFileType = (url) =>
  fetch(url)
    .then((response) => response.blob())
    .then((blob) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      }).then((image) => {
        const startIndex = image.search(":") + 1;
        const endIndex = image.search(";");
        const type = image.slice(startIndex, endIndex);

        if (type.startsWith("image")) {
          return "image";
        } else if (type.startsWith("video")) {
          return "video";
        } else if (type.startsWith("audio")) {
          return "audio";
        } else {
          return type;
        }
      })
    );
